<template>
    <v-card style="border-radius:4px;"> 
        <v-toolbar flat height="45px">  
            <b>View All Team Members</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>                      
        </v-toolbar>
        <v-card-text>
            <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details style="margin:0px 0px 15px 20px; width:50%;"></v-text-field>  
            <v-data-table
                :headers="headers"
                :items="time_reports_filtered"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="paginationSync"
            >
                <template v-slot:items="props">
                    <tr @click="viewUserTimesheet(props.item.userId)" title="Click to view details" style="cursor:pointer;" >
                        <td>
                            <v-chip style="margin:-5px 0px 0px -5px;">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                </v-avatar>
                                {{props.item.firstName}} {{props.item.lastName}}
                            </v-chip>
                        </td>
                        <td>
                            <b v-if="commonfn.getStatusDescription(props.item.status)=='Not Available'" :class="commonfn.getStatusColor(props.item.status)">Unsubmitted</b>
                            <b v-else :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data () {
        const routeName = `${this.$route.name}-ViewAllEmployeesPopup`
        const savedSort = userPrefs.getSort(routeName)
        
        return {
            awsS3Helper,
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: null,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'75%', sortable:true},
                {text: 'Timesheet Status', align: 'left', value: 'status', width: '25%', sortable:true}
            ],
            time_reports: []
        }   
    },
    methods: {
        viewUserTimesheet(userId) {
            this.$emit('send', userId)
            this.closeDialog()
        },
        async getTeamTimeReports(cutOffId, accessedFromCompanyPages) {
            try {
                this.loading = true
                let response = null
                
                if (accessedFromCompanyPages) {
                    response = await timesheetApi.getTimeReportByCompany(cutOffId)  
                }else{
                    response = await timesheetApi.getTimeReportByTeam(cutOffId)  
                }         
                if (response && response.status == 200) {
                    this.time_reports = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAllEmployees', false)
        },
    },
    created() {},
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-ViewAllEmployeesPopup`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-ViewAllEmployeesPopup`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-ViewAllEmployeesPopup`, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        time_reports_filtered() {
            var temp = this.time_reports

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
    }
}
</script>